import React from 'react';
import Card from 'react-bootstrap/Card';
import withNameDatepicker from './hoc-datepicker';
import withNameInput from './hoc-input';
import withNameSelect from './hoc-select';
import withNameTextarea from './hoc-textarea';
import Header from './header';
import Pane from './pane';

const InceptionDate = withNameDatepicker('inceptionDate', 'Inception Date');
const Objective = withNameTextarea('objective', 'Fund Objective');
const FundAssetClass = withNameSelect('fundAssetClass');
const GeographicalFocus = withNameInput('geographicalFocus', 'Geographical Focus');
const InvestmentHorizon = withNameSelect('investmentHorizon', 'Investment Horizon');
const MinimumInvestment = withNameInput('minimumInvestment', 'Minimum Initial Investment');
const Currency = withNameInput('currency', 'Currency');
const LegalStructure = withNameInput('legalStructure', 'Legal Structure');
const Domicile = withNameInput('domicile', 'Domicile');

export default function FundFacts() {
  return (
    <Card>
      <Card.Header>
        <Header eventKey="facts">Fund Facts</Header>
      </Card.Header>
      <Pane eventKey="facts">
        <Card.Body>
          <InceptionDate />
          <Objective />
          <FundAssetClass />
          <GeographicalFocus />
          <InvestmentHorizon />
          <MinimumInvestment />
          <Currency />
          <LegalStructure />
          <Domicile />
        </Card.Body>
      </Pane>
    </Card>
  );
}
